// Reads the GA4 client_id from the browser's _ga cookie so server-side Measurement
// Protocol events (qualify_lead, purchase) can be tied back to the organic/paid
// session that brought the visitor in, instead of creating an orphan GA4 session.
// _ga cookie format: GA1.<version>.<client_id_part1>.<client_id_part2>
export function getGaClientId() {
  try {
    const match = document.cookie.match(/(?:^|; )_ga=([^;]+)/);
    if (!match) return null;
    const parts = decodeURIComponent(match[1]).split('.');
    if (parts.length >= 4) return `${parts[2]}.${parts[3]}`;
    return null;
  } catch {
    return null;
  }
}